import React from 'react';
import Acord25Form from './Acord25Form';
import type { Acord25FormRef } from './Acord25Form';
import type { StoredCoverage, StoredPolicy } from '../../utils/parseAcord25StoredCoverages';

export type { Acord25FormRef };

interface Acord25With101FormProps {
  selectedPolicies?: string[];
  insuredId?: string;
  fileParentId?: string;
  editCoverages?: StoredCoverage[];
  editPolicies?: StoredPolicy[];
  initialCglAddlInsd?: boolean;
  initialCglSbrWvd?: boolean;
  initialAutoAddlInsd?: boolean;
  initialAutoSbrWvd?: boolean;
  initialUmbrellaAddlInsd?: boolean;
  initialUmbrellaSbrWvd?: boolean;
  initialWcAddlInsd?: boolean;
  initialWcSbrWvd?: boolean;
  initialOther1AddlInsd?: boolean;
  initialOther1SbrWvd?: boolean;
}

const Acord25With101Form = React.forwardRef<Acord25FormRef, Acord25With101FormProps>(
  function Acord25With101Form({ selectedPolicies = [], insuredId = '', fileParentId, editCoverages, editPolicies, initialCglAddlInsd, initialCglSbrWvd, initialAutoAddlInsd, initialAutoSbrWvd, initialUmbrellaAddlInsd, initialUmbrellaSbrWvd, initialWcAddlInsd, initialWcSbrWvd, initialOther1AddlInsd, initialOther1SbrWvd }, ref) {
    return <Acord25Form ref={ref} showAcord101 selectedPolicies={selectedPolicies} insuredId={insuredId} fileParentId={fileParentId} editCoverages={editCoverages} editPolicies={editPolicies} initialCglAddlInsd={initialCglAddlInsd} initialCglSbrWvd={initialCglSbrWvd} initialAutoAddlInsd={initialAutoAddlInsd} initialAutoSbrWvd={initialAutoSbrWvd} initialUmbrellaAddlInsd={initialUmbrellaAddlInsd} initialUmbrellaSbrWvd={initialUmbrellaSbrWvd} initialWcAddlInsd={initialWcAddlInsd} initialWcSbrWvd={initialWcSbrWvd} initialOther1AddlInsd={initialOther1AddlInsd} initialOther1SbrWvd={initialOther1SbrWvd} />;
  }
);

export default Acord25With101Form;
